import { alpha, styled, TableCell, TableRow } from '@mui/material';
import { FONT_MONO } from 'themes/tokens';

export const UserTableRow = styled(TableRow)(({ theme }) => ({
  '&.MuiTableRow-hover:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  },
}));

export const UsersTableCard = styled('div')(({ theme }) => ({
  borderRadius: '14px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.03),
  overflowX: 'auto',
}));

export const HeadCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.72rem',
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
}));

export const UsernameCell = styled(TableCell)(({ theme }) => ({
  fontFamily: FONT_MONO,
  fontSize: '0.82rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
}));

export const MetaCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));

export const TableFooterBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const EmptyState = styled('div')(({ theme }) => ({
  padding: theme.spacing(5, 2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
